var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBusinessUnit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80546 2.30546C7.32118 1.78973 8.02065 1.5 8.75 1.5H15.25C15.9793 1.5 16.6788 1.78973 17.1945 2.30546C17.7103 2.82118 18 3.52065 18 4.25V6H21.25C22.7688 6 24 7.23122 24 8.75V12V13.5V19.75C24 21.2688 22.7688 22.5 21.25 22.5H2.75C1.23122 22.5 0 21.2688 0 19.75V13.5V12V8.75C0 7.23122 1.23122 6 2.75 6H6V4.25C6 3.52065 6.28973 2.82118 6.80546 2.30546ZM1.5 13.5V19.75C1.5 20.4404 2.05964 21 2.75 21H21.25C21.9404 21 22.5 20.4404 22.5 19.75V13.5H18V14.25C18 14.6642 17.6642 15 17.25 15C16.8358 15 16.5 14.6642 16.5 14.25V13.5H7.5V14.25C7.5 14.6642 7.16421 15 6.75 15C6.33579 15 6 14.6642 6 14.25V13.5H1.5ZM22.5 12H18V11.25C18 10.8358 17.6642 10.5 17.25 10.5C16.8358 10.5 16.5 10.8358 16.5 11.25V12H7.5V11.25C7.5 10.8358 7.16421 10.5 6.75 10.5C6.33579 10.5 6 10.8358 6 11.25V12H1.5V8.75C1.5 8.05964 2.05964 7.5 2.75 7.5H6.75H17.25H21.25C21.9404 7.5 22.5 8.05964 22.5 8.75V12ZM16.5 4.25V6H7.5V4.25C7.5 3.91848 7.6317 3.60054 7.86612 3.36612C8.10054 3.1317 8.41848 3 8.75 3H15.25C15.5815 3 15.8995 3.1317 16.1339 3.36612C16.3683 3.60054 16.5 3.91848 16.5 4.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBusinessUnit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/business-unit.dcacd8144c7fea1d619cb5510853a39a.svg";